<section *ngIf="step == 1">
    <h3 class="bold" transloco="phone_confirmation.title1">Verify your phone pumber and get your lab results</h3>

    <ul class="nav-steps my-3">
        <li class="circle" [class.done]="step > 1" [class.current]="step < 2">1</li>
        <li class="line" [class.done]="step > 1"></li>
        <li class="circle" [class.done]="step > 2" [class.current]="step > 1">2</li>
    </ul>

    <p transloco="phone_confirmation.getLabsMessage" [translocoParams]="{user: profileData.first_name | transloco}"></p>

    <div>
        <div class="input-container">
            <!-- #username="ngModel" ngModel required email -->
            <div class="mt-4">
                <label class="input-label required" for="phone" transloco="phone">Phone</label>
                <ng-container *ngFor="let phone of profileData.phones">
                    <input *ngIf="phone.primary || profileData.phones.length == 0" name="phone" id="phone" type="text" class="mx-auto" required [(ngModel)]="phone.number" mask="(000) 000-0000" placeholder="(000) 000-0000">
                </ng-container>
            </div>

            <div class="" style="display: flex; flex-wrap: wrap;">
                <button class="ab_button filled col mt-5 mb-4 mr-2" (click)="onLogout()" type="submit" transloco="logOut">Logout</button>
                <button class="ab_button filled col mt-5 mb-4 ml-2" (click)="submitPhone()" [loading]="loading" type="submit" transloco="getCode">Get code</button>
            </div>
            <!-- <div class="input-error">
              <span *ngIf="username.invalid && username.dirty" transloco="textError"></span>
            </div> -->
        </div>
    </div>
</section>

<section *ngIf="step == 2">
    <h3 class="bold" transloco="phone_confirmation.title2">Enter Your Verification Code</h3>

    <ul class="nav-steps my-3">
        <li class="circle" [class.done]="step > 1" [class.current]="step < 2">1</li>
        <li class="line" [class.done]="step > 1"></li>
        <li class="circle" [class.done]="step > 2" [class.current]="step > 1">2</li>
    </ul>

    <p transloco="phone_confirmation.confirmationCode" [translocoParams]="{user: profileData.first_name, phone: phoneSubstring | transloco}">Great job, Aleksandr! We've sent a 6-digit verification code to your phone ends in ####. Please enter it below to continue. This ensures that your lab results are sent only to you, keeping your information safe and secure.</p>

    <div>
        <div class="input-container">
            <div class="mt-4">
                <!-- transloco="phone" -->
                <label class="input-label required" for="confrimation_code" transloco="phone_confirmation.verification_code">Verification Code</label>
                <input style="letter-spacing: 10px;" name="confrimation_code" id="confrimation_code" type="text" class="mx-auto" required [(ngModel)]="confrimation_code" mask="000000" placeholder="_ _ _ _ _ _">
                <span class="error_code" *ngIf="errorCodes.length > 0">{{errorCodes[0]}}</span>
            </div>

            <div class="" style="display: flex; flex-wrap: wrap;">
                <button class="ab_button filled col mt-5" (click)="sendConfirmationCode()" [loading]="loading" transloco="regCodeSend">Verify</button>
            </div>

            <hr class="my-5">

            <p style="text-align: center;" transloco="phone_confirmation.not_recived">Didn't receive a code? It usually takes less than 5 minutes.</p>

            <div class="" style="display: flex; flex-wrap: wrap;">
                <button class="ab_button filled col mt-5" (click)="sendCode()" transloco="regCodeResend">Resend Code</button>
            </div>

            <a style="text-align: center;" class="mt-5" (click)="step = 1" transloco="phone_confirmation.change_number"> Still not receiving the code? Change phone number </a>
        </div>
    </div>
</section>

<section *ngIf="step == 3">
    <h3 class="bold" transloco="phone_confirmation.title3">Verification Successful!</h3>

    <p transloco="phone_confirmation.confirmationSuccessful" [translocoParams]="{user: profileData.first_name | transloco}">Thank you, John! Your phone number has been successfully verified. Now you're all set to receive your lab results securely and promptly. We appreciate you taking this step to ensure your information's safety.</p>

    <div class="" style="display: flex; flex-wrap: wrap;">
        <button class="ab_button filled col mt-5" (click)="closeModal()" transloco="closeWin">Resend Code</button>
    </div>
</section>
